module.exports = __webpack_public_path__ + "static/media/dental-catalog.6884cae1.pdf";